import { render } from "./Fietsenstallingen.vue?vue&type=template&id=35aa4a69"
import script from "./Fietsenstallingen.vue?vue&type=script&lang=js"
export * from "./Fietsenstallingen.vue?vue&type=script&lang=js"

import "./Fietsenstallingen.vue?vue&type=style&index=0&id=35aa4a69&lang=css"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__